import React, { useState } from "react";
import { TeamData } from "./ExpandableTable";
import { TiArrowSortedDown } from "react-icons/ti";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../../contexts/app-context/AppContext";
import { useTeams } from "../../../contexts/teams-context/TeamsContext";

interface IProps {
  onStatusUpdate: (isLoading: boolean) => void;
  team: TeamData;
}

const ExpandableRow = (props: IProps) => {
  const [lock, setLock] = useState(false);
  const [show, setShow] = useState(false);
  const { push } = useHistory();
  const app = useAppContext();
  const { updateTeamActiveStatus } = useTeams();

  const changeState = (newActiveStatus: boolean) => {
    updateTeamActiveStatus(
      props.team.id,
      newActiveStatus,
      () => {
        setLock(true);
        props.onStatusUpdate(true);
      },
      () => {
        setLock(false);
        props.onStatusUpdate(false);
      }
    );
  };

  return (
    <>
      <tr className="team-item">
        <td
          className="expand-icon"
          onClick={() => {
            setShow(!show);
          }}
        >
          <TiArrowSortedDown
            style={
              show
                ? {
                    transform: "rotate(180deg) translateY(2px)",
                  }
                : {
                    transform: "rotate(0deg)",
                  }
            }
          />
        </td>
        <td>
          <label
            className="link-label mb-0"
            onClick={() => {
              props.team.onClick(props.team.id);
            }}
          >
            {props.team.name}
          </label>
        </td>
        <td>{props.team.status}</td>
        <td>{props.team.country}</td>
        <td>
          <button
            className={
              lock
                ? "app-button-disabled"
                : props.team.status === "Active"
                ? "app-button-deactivate"
                : "app-button-activate"
            }
            onClick={() => {
              if (!lock) {
                changeState(props.team.status !== "Active");
              }
            }}
            disabled={lock}
          >
            {props.team.status === "Active" ? "Deactivate" : "Activate"}
          </button>
          <button
            className="app-button-small ml-2"
            onClick={() =>
              props.team.onEdit && props.team.onEdit(props.team.id)
            }
          >
            edit
          </button>
        </td>
      </tr>
      {show && (
        <tr className="members-item">
          <td colSpan={5} className="animated fadeIn">
            <Container
              fluid
              style={{ paddingLeft: "200px", paddingRight: "200px" }}
            >
              {/*<Row>*/}
              {/*  <Col xs={12}> <label>{props.team.name}</label></Col>*/}

              {/*</Row>*/}
              <Row>
                <Col xs={12}>
                  <table className="team-table">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.team.members.map((member, index) => (
                        <tr key={index}>
                          <td>
                            <label
                              className="link-label"
                              onClick={() => {
                                app.pushBackURL("/dashboard/teams");
                                push("/dashboard/teams/members/" + member.id);
                              }}
                            >
                              {member.fullName}
                            </label>
                          </td>
                          <td>{member.email}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Container>
          </td>
        </tr>
      )}
    </>
  );
};
export default ExpandableRow;
